/* AULBERY — Product hotspots (as-hotspots.js)
   Moved 1:1 from the inline <script> in sections/as-hotspots.liquid. Every
   value Liquid used to write into the script now comes from data attributes
   on the [data-as-hotspots] root, and the titles / copies arrays from the
   <script type="application/json" data-ash-data> block inside it. Timers,
   the IntersectionObserver and the window / matchMedia listeners are stored
   on the root and torn down on shopify:section:unload. V2 (as-shop-the-look)
   has its own copy. */
(function () {
  function num(v, fallback) {
    var n = parseFloat(v);
    return isNaN(n) ? fallback : n;
  }

  function initHot(root) {
    if (!root || root.dataset.asHotspotsInit === '1') return;
    root.dataset.asHotspotsInit = '1';
    var ds = root.dataset;

    var pins = Array.prototype.slice.call(root.querySelectorAll('[data-ash-pin]'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-ash-row]'));
    var segs = Array.prototype.slice.call(root.querySelectorAll('[data-ash-seg]'));
    var inner = root.querySelector('[data-ash-card]');
    var titleEl = root.querySelector('[data-ash-title]');
    var copyEl = root.querySelector('[data-ash-copy]');
    var countEl = root.querySelector('[data-ash-count]');
    if (!pins.length) return;

    var dataEl = root.querySelector('[data-ash-data]');
    var data = {};
    try {
      data = JSON.parse(dataEl.textContent) || {};
    } catch (e) {
      data = {};
    }
    var titles = data.titles || [];
    var copies = data.copies || [];
    var total = pins.length;
    var active = -1;
    var fanStep = num(ds.fanStep, 12);
    var fanMin = num(ds.fanMin, 8);
    var fanMax = num(ds.fanMax, 92);
    var swapMs = num(ds.swapMs, 170);
    var countSep = ds.countSep !== undefined ? ds.countSep : ' / ';
    var countPad = ds.countPad !== 'false';

    // every pending timeout, so unload can clear them
    var timers = [];
    function later(fn, ms) {
      var t = setTimeout(function () {
        var at = timers.indexOf(t);
        if (at > -1) timers.splice(at, 1);
        fn();
      }, ms);
      timers.push(t);
    }

    // if two pins were left on identical coordinates, fan them apart so
    // none is hidden underneath another
    var seen = {};
    pins.forEach(function (p) {
      var key = p.style.left + '|' + p.style.top;
      if (seen[key] === undefined) {
        seen[key] = 0;
      } else {
        seen[key] += 1;
        var n = seen[key];
        var x = parseFloat(p.style.left) || 50;
        var y = parseFloat(p.style.top) || 50;
        p.style.left = Math.min(fanMax, Math.max(fanMin, x + n * fanStep)) + '%';
        p.style.top = Math.min(fanMax, Math.max(fanMin, y + n * fanStep)) + '%';
      }
    });

    // reserve the tallest possible list height so expanding a row never
    // resizes the column (which was making the heading jump).
    var list = root.querySelector('.ash-list');
    var copyGap = num(ds.rowCopyGap, 5);
    function lockListHeight() {
      if (!list || !rows.length) return;
      if (!list.offsetHeight) return;
      var prev = rows.map(function (r) { return r.classList.contains('is-on'); });
      list.style.minHeight = '';
      rows.forEach(function (r) { r.classList.remove('is-on'); });
      var base = list.offsetHeight;
      var tallestCopy = 0;
      rows.forEach(function (r) {
        var c = r.querySelector('.ash-row-copy');
        if (!c) return;
        var h = c.scrollHeight;
        if (h > tallestCopy) tallestCopy = h;
      });
      rows.forEach(function (r, n) { r.classList.toggle('is-on', prev[n]); });
      list.style.minHeight = Math.ceil(base + tallestCopy + copyGap) + 'px';
    }

    function pad(n) {
      if (!countPad) return String(n);
      return n < 10 ? '0' + n : String(n);
    }

    function show(i, animate) {
      if (i === active || i < 0 || i >= total) return;
      active = i;
      pins.forEach(function (p, n) {
        p.classList.toggle('is-on', n === i);
      });
      rows.forEach(function (r, n) {
        r.classList.toggle('is-on', n === i);
      });
      segs.forEach(function (s, n) {
        s.classList.toggle('is-on', n === i);
      });
      if (!inner) return;

      function paint() {
        if (titleEl) titleEl.textContent = titles[i] || '';
        if (copyEl) copyEl.textContent = copies[i] || '';
        if (countEl) countEl.textContent = pad(i + 1) + countSep + pad(total);
      }

      if (animate === false) {
        paint();
        return;
      }
      inner.classList.add('is-out');
      later(function () {
        paint();
        inner.classList.remove('is-out');
      }, swapMs);
    }

    pins.forEach(function (p) {
      p.addEventListener('click', function () {
        autoStopForGood();
        show(parseInt(p.dataset.ashPin, 10), true);
      });
    });

    var rowHover = ds.rowHover !== 'false';
    rows.forEach(function (r) {
      var i = parseInt(r.dataset.ashRow, 10);
      r.addEventListener('click', function () { autoStopForGood(); show(i, true); });
      if (rowHover) {
        r.addEventListener('mouseenter', function () { autoStopForGood(); show(i, true); });
      }
    });

    segs.forEach(function (s) {
      s.addEventListener('click', function () {
        autoStopForGood();
        show(parseInt(s.dataset.ashSeg, 10), true);
      });
    });

    show(0, false);

    // ---------- auto-rotate ----------
    // Same modes as the carousels. Once anyone picks a hotspot themselves
    // it stops for good — stepping the card out from under someone who is
    // reading it is worse than not rotating at all.
    var autoMs = num(ds.autoMs, 5) * 1000;
    var autoMode = ds.autoMode || 'off';
    var autoTimer = null;
    var stopped = false;
    var inView = true;
    var mq = window.matchMedia('(max-width: ' + num(ds.mobileMax, 989) + 'px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function autoAllowed() {
      return !stopped && (autoMode === 'all' || (autoMode === 'mobile' && mq.matches));
    }
    function autoStop() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }
    function autoStopForGood() {
      stopped = true;
      autoStop();
    }
    function autoStart() {
      autoStop();
      if (!autoAllowed() || !inView || reduce.matches || total < 2) return;
      autoTimer = window.setInterval(function () {
        if (!autoAllowed() || !inView || reduce.matches) { autoStop(); return; }
        show((active + 1) % total, true);
      }, autoMs);
    }

    var io = null;
    if (window.IntersectionObserver) {
      io = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) { autoStart(); } else { autoStop(); }
      }, { threshold: num(ds.visibleThreshold, 30) / 100 });
      io.observe(root);
    }
    if (mq.addEventListener) mq.addEventListener('change', autoStart);
    autoStart();

    var rt;
    var onResize = null;
    if (list) {
      window.requestAnimationFrame(lockListHeight);
      // fonts and images can land late; re-measure once things settle
      later(lockListHeight, num(ds.remeasureFirst, 400));
      later(lockListHeight, num(ds.remeasureSecond, 1200));
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(lockListHeight);
      }
      var debounce = num(ds.resizeDebounce, 200);
      onResize = function () {
        clearTimeout(rt);
        rt = setTimeout(lockListHeight, debounce);
      };
      window.addEventListener('resize', onResize);
    }

    root.asHotspotsCleanup = function () {
      autoStop();
      if (io) { io.disconnect(); io = null; }
      if (mq.removeEventListener) mq.removeEventListener('change', autoStart);
      if (onResize) { window.removeEventListener('resize', onResize); onResize = null; }
      clearTimeout(rt);
      timers.forEach(function (t) { clearTimeout(t); });
      timers = [];
    };
  }

  function scopeOf(e) {
    return e && e.target && e.target.querySelectorAll ? e.target : document;
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-as-hotspots]'), initHot);
  }

  function unloadAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-as-hotspots]'), function (root) {
      if (typeof root.asHotspotsCleanup === 'function') root.asHotspotsCleanup();
      root.dataset.asHotspotsInit = '';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  // the editor re-runs this file when it re-renders a section; bind the
  // document listeners once
  if (!window.asHotspotsBound) {
    window.asHotspotsBound = true;
    document.addEventListener('shopify:section:load', function (e) { initAll(scopeOf(e)); });
    document.addEventListener('shopify:section:unload', function (e) { unloadAll(scopeOf(e)); });
  }
})();

